import CandidatePathwaysContainer from './candidate_pathways_container';

const CandidatePathways = CandidatePathwaysContainer;
export default CandidatePathways;
